<template>
  <vx-card no-shadow>
    <vs-input
     type="password"
      class="w-full mb-base"
      label-placeholder="Altes Passwort"
      v-model="old_password"
    />
    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Neues Passwort"
      v-model="new_password"
    />
    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Neues Passwort bestätigen"
      v-model="confirm_new_password"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="onChangePassword"
        >Speichern</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    };
  },
  methods: {
    ...mapActions({
      changePassword: "auth/changePassword",
    }),
    onChangePassword() {
      if (this.new_password !== this.confirm_new_password) {
          this.$vs.notify({
            title: "Fehler",
            text: "Die Passwörter müssen übereinstimmen",
            color: "danger",
            position: "top-center",
            icon: "error",
          });
          return;
      }
      this.changePassword({
        password: this.old_password,
        newPassword: this.new_password,
      })
        .then(() => {
          this.$vs.notify({
            title: "Erfolg",
            text: "Dein Passwort wurde erfolgreich geändert",
            color: "success",
            position: "top-center",
            icon: "favorite",
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fehler",
            text: "Es ist ein Fehler aufgetreten",
            color: "danger",
            position: "top-center",
            icon: "error",
          });
        });
    },
  },
};
</script>
